import { useTranslation } from "next-i18next"

const useTradeMembershipi18n = dataProps => {
  const { t } = useTranslation()
  const i18n = {
    requiredInfoText: t("kf.auth.label.requiredFields"),
    yes: t("kf.contactus.label.yes"),
    no: t("kf.contactus.label.no"),
    contactInformation: t("kf.contactus.label.contactInformation"),
    fname: t("kf.contactus.label.firstName"),
    lname: t("kf.contactus.label.lastName"),
    email: t("kf.contactus.label.emailAddress"),
    typeOf: t("kf.contactus.label.typeOf"),
    address: t("kf.contactus.label.address"),
    aptFloorSuite: t("kf.contactus.label.aptFloorSuite"),
    city: t("kf.contactus.label.city"),
    state: t("kf.contactus.label.state"),
    zipcode: t("kf.contactus.label.zipCode"),
    country: t("kf.contactus.label.country"),
    phoneNumber: t("kf.contactus.label.phoneNumber"),
    uploadCountLimit:
      dataProps?.errorMessage || t("kf.contactus.label.uploadCountLimit"),
    uploadFileTypes: t("kf.contactus.label.uploadFileTypes"),
    uploadSizeLimit: t("kf.contactus.label.uploadSizeLimit"),
    uploadMBLimit: t("kf.contactus.label.uploadMBLimit"),
    dragAndDrop: t("kf.contactus.label.dragAndDrop"),
    orText: t("kf.contactus.label.orText"),
    uploadFileButton: t("kf.contactus.label.uploadFileButton"),
    submitButton: t("kf.contactus.label.submitButton"),
    privacyPolicy: t("kf.contactus.label.privacyPolicy"),
    subjectAccessRequest: t("kf.contactus.label.subjectAccessRequest"),
    termsOfService: t("kf.contactus.label.termsOfService"),
    messageSent: dataProps?.successtitle ?? t("kf.contactus.label.messageSent"),
    responseReceiveTime:
      dataProps?.successdescription ??
      t("kf.contactus.label.responseReceiveTime"),
    startShopping:
      dataProps?.ctalabel ?? t("kf.trademembership.label.startShopping"),
    fnameError: t("kf.contactus.error.fnameError"),
    lnameError: t("kf.contactus.error.lnameError"),
    noEmailError: t("kf.contactus.error.noEmailError"),
    validEmail: t("kf.contactus.error.validEmail"),
    noCompanyError: t("kf.contactus.error.noCompanyError"),
    addressError: t("kf.contactus.error.addressError"),
    cityError: t("kf.contactus.error.cityError"),
    stateError: t("kf.contactus.error.stateError"),
    zipcodeError: t("kf.contactus.error.zipcodeError"),
    validZipcode: t("kf.contactus.error.validZipcode"),
    validPhone: t("kf.contactus.error.validPhone"),
    noPhoneError: t("kf.contactus.error.noPhoneError"),
    errorFileType: t("kf.trademembership.error.fileFormatType"),
    errorMaxFileSizeLimit: t("kf.contactus.error.maxFileSizeLimit"),
    serverError: dataProps?.errorMessage ?? t("kf.contactus.error.serverError"),
    genError: t("kf.error.message.genericError"),
    ariaLabels: {
      imageRemove: t("kf.registerOfflineProduct.label.aria.removeImage"),
    },
    commentBoxPlaceholder: t("kf.registerOfflineProduct.label.addComment"),
    primaryAddress: t("kf.account.label.primaryAddress"),
    jobType: t("kf.trademembership.label.jobType"),
    companyWebsite: t("kf.trademembership.label.companyWebsite"),
    company: t("kf.trademembership.label.company"),
    exHomeLabel: t("kf.trademembership.label.exHomeLabel"),
    asTradeCustomer: t("kf.trademembership.label.asTradeCustomer"),
    businessInformation: t("kf.keyspecifier.label.businessInformation"),
    uploadDoc: t("kf.trademembership.label.uploadBusinessDoc"),
    attachDoc: t("kf.trademembership.label.attachBusinessDoc"),
    designCert: t("kf.trademembership.label.interiorDesignCert"),
    designMembership: t("kf.trademembership.label.membershipDesignOrg"),
    businessLicense: t("kf.trademembership.label.businessLicense"),
    uploadFormatType: t("kf.trademembership.label.supportedFormat"),
    taxMsg: t("kf.trademembership.label.taxMessageText"),
    taxReqLabel: t("kf.trademembership.label.taxRequestLabel"),
    termsAndConsCheck: t("kf.trademembership.label.termsAndConditionCheck"),
    termsAndConsLabel: t("kf.trademembership.label.termsAndCondition"),
    newsletterCheck: t("kf.trademembership.label.newsletterCheck"),
    timeNedded: t("kf.trademembership.label.requiredDuration"),
    companyWebsiteError: t("kf.trademembership.error.companyWebsite"),
    jobTypeError: t("kf.trademembership.error.jobType"),
    subJobTypeError: t("kf.trademembership.error.subJobType"),
  }

  return i18n
}

export default useTradeMembershipi18n
